/**
 * React key for a transient attack badge pair.
 *
 * Live entries carry a hook-unique `animationId`, and the key is that id alone.
 * It must NOT include the array position: entries are appended as attacks land
 * and swept when they expire, so a later entry moves from index 1 to 0 while it
 * is still playing. A position in the key remounted it at that moment, and its
 * damage flash and loss label played a second time (seen as a double flash on a
 * single attack, 2026-10-28).
 *
 * Without an id (legacy or snapshot entries) the event timestamp is not unique:
 * a blitz can produce entries in the same millisecond, and reconnect/replay can
 * queue two before the sweep runs. Only then does the position break the tie.
 */
export function attackAnimationKey(
  entry: {
    animationId?: string
    attackerTerritoryId: string
    defenderTerritoryId: string
    startedAt: number
  },
  index: number,
): string {
  if (entry.animationId) return `attack-${entry.animationId}`
  return `attack-${entry.attackerTerritoryId}-${entry.defenderTerritoryId}-${entry.startedAt}-${index}`
}
